import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { BodyText } from '@calendly/ui/components/typography';
import { CheckboxField } from '@calendly/ui/form/checkbox-field';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
const wrapperCss = "wtgadsy";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
export const RemoveOrgAdminCheckbox = ({
  onChange,
  suggestion
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const handleOnChange = isOrgAdminToRemove => {
    setIsChecked(!isChecked);
    onChange(isOrgAdminToRemove, suggestion);
  };
  return <ContextualBanner>
      <Wrapper>
        <BodyText>
          <em>{I18n.t('publisher.organization.user_groups.management.remove_org_admin_explanation')}</em>
        </BodyText>
        <CheckboxField checked={isChecked} onChange={handleOnChange} label={I18n.t('publisher.organization.user_groups.management.checkbox_label')} />
      </Wrapper>
    </ContextualBanner>;
};

require("./remove_org_admin_checkbox.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./remove_org_admin_checkbox.js");